import { render, staticRenderFns } from "./McustomerUpdate.vue?vue&type=template&id=11c54a0e"
import script from "./McustomerUpdate.vue?vue&type=script&lang=js"
export * from "./McustomerUpdate.vue?vue&type=script&lang=js"
import style0 from "./McustomerUpdate.vue?vue&type=style&index=0&id=11c54a0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports